import I18n from 'i18n';

const t = (key, opts) => I18n.t(`datetime.distance_in_words.${key}`, opts);

export function distanceOfTimeInWords(fromTime, toTime, includeSeconds) {
  const fromSeconds = fromTime.getTime();
  const toSeconds = toTime.getTime();
  const distanceInSeconds = Math.round(Math.abs(fromSeconds - toSeconds) / 1000);
  const distanceInMinutes = Math.round(distanceInSeconds / 60);
  const distanceInHours = Math.round(distanceInMinutes / 60);
  const distanceInDays = Math.round(distanceInMinutes / 1440);
  const distanceInMonths = Math.round(distanceInMinutes / 43200);
  const distanceInYears = Math.round(distanceInMinutes / 525600);

  if (distanceInMinutes <= 1) {
    if (!includeSeconds) return (distanceInMinutes === 0) ? t('less_than_x_minutes', { count: 1 }) : t('x_minutes', { count: 2 });

    if (distanceInSeconds < 5) return t('less_than_x_seconds', { count: 5 }); // 'less than 5 seconds'

    if (distanceInSeconds < 10) return t('less_than_x_seconds', { count: 10 }); // 'less than 10 seconds'

    if (distanceInSeconds < 20) return t('less_than_x_seconds', { count: 20 }); // 'less than 20 seconds'

    if (distanceInSeconds < 40) return t('half_a_minute'); // 'half a minute'

    if (distanceInSeconds < 60) return t('less_than_x_minutes', { count: 1 }); // return t('less_than_x_seconds', {count: 20}) //'less than 20 seconds'

    return t('less_than_x_minutes', { count: 1 });
  }

  if (distanceInMinutes < 45) return t('x_minutes', { count: distanceInMinutes });

  if (distanceInMinutes < 90) return t('about_x_hours', { count: 1 });

  if (distanceInMinutes < 1440) return t('about_x_hours', { count: distanceInHours });

  if (distanceInMinutes < 2880) return t('x_days', { count: 1 });

  if (distanceInMinutes < 43200) return t('x_days', { count: distanceInDays });

  if (distanceInMinutes < 86400) return t('about_x_months', { count: 1 });

  if (distanceInMinutes < 525600) return t('x_months', { count: distanceInMonths });

  if (distanceInMinutes < 1051200) return t('about_x_years', { count: 1 });

  return t('over_x_years', { count: distanceInYears });
}

export const timeAgoInWords = (fromTime, includeSeconds) => (
  distanceOfTimeInWords(new Date(), fromTime, includeSeconds)
);

export default function mutateTimeAgo(n) {
  let final = `${n.dataset.timeago}0000`;
  final = final.replace('.', '').match(/^\d{0,13}/)[0]; // eslint-disable-line
  final = parseInt(final, 10);
  const val = timeAgoInWords(new Date(final), true);
  if (n.innerText !== val) {
    n.innerText = val; // eslint-disable-line
  }
}
